export default function About() {
  return (
    <section id="about" className="py-32 px-20 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 gap-20 items-start">
          {/* Left Content */}
          <div className="relative">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A961]"></div>
            <div className="pl-12">
              <h2 className="text-5xl font-bold text-[#2C2C2C] mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
                About the Author
              </h2>
              <p className="text-xl text-[#2C2C2C] leading-relaxed mb-6" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
                After 30 plus years of dwelling and debating on it all, this is my attempt to logically explain what and why I believe regarding Christianity having actually read the entire story, front to back, 3 times.
              </p>
              <p className="text-xl text-[#2C2C2C] leading-relaxed mb-6" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
                Me in a nutshell: 64, born into a Christian family, mother very devout, but mentally distraught and emotionally unstable to the point of being extremely offensive to any and all she might meet.
              </p>
              <p className="text-xl text-[#2C2C2C] leading-relaxed mb-6" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
                Having been dragged to many a church of various denominations during my youth, the turmoil within the family left me with disdain for my mother and Christianity.
              </p>
              <p className="text-xl text-[#2C2C2C] leading-relaxed mb-16" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
                Through decades of reflection and study, I've distilled my understanding into a work that makes the Bible accessible to those who struggle to find time to read it in its entirety.
              </p>

              <div className="inline-flex items-center gap-3 px-6 py-3 bg-[#D4E5D4] rounded-full mb-16">
                <i className="ri-book-open-line text-[#2C2C2C]"></i>
                <span className="text-sm text-[#2C2C2C] font-medium whitespace-nowrap">Biblical Scholar & Author</span>
              </div>

              <div className="flex gap-20">
                <div>
                  <div className="text-7xl font-bold text-[#2C2C2C] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>30+</div>
                  <div className="text-sm text-[#6B6B6B]">Years of Study</div>
                </div>
                <div>
                  <div className="text-7xl font-bold text-[#2C2C2C] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>3x</div>
                  <div className="text-sm text-[#6B6B6B]">Complete Bible Readings</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.12)' }}>
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/b62137b3168c8df48bb92b54f7f75433.jpeg"
                  alt="Author Portrait"
                  className="w-full h-[700px] object-cover object-top"
                />
                <div className="absolute top-8 left-8 bg-white rounded-2xl px-6 py-3 shadow-lg">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-[#C9A961]"></i>
                    <span className="text-sm font-medium text-[#2C2C2C] whitespace-nowrap">Richard Pontefract</span>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1A2332]/60 to-transparent p-8">
                  <p className="text-white text-base font-light mb-1">Author of Gen 1</p>
                  <p className="text-white/80 text-sm">Making the Bible Accessible to Modern Readers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
